
(function () {
	"use strict";

	function SpaceView() {
		this.View_constructor();

		this.build();
	}

	var p = createjs.extend(SpaceView, cm.View);

	p.build = function () {
		cm.main.pause = false;
		this.storedSettings = null;
		this.checkStorages();
		this.width = cm.app.display.width * 0.5;
		this.spaceContainer = new cjs.Container();
		this.levelUI = new cjs.Container();
		this.xDifference = 0;
		cm.main.score = 0;
		cm.app.music = null;
		this.moveLeft = false;
		this.moveRight = false;
		this.presentAppear = false;
		this.releaseDiff = 0;
		this.percentEase = 0;
		this.mouseX = 0;
		this.mapRelease = true;
		this.scalePlanet = null;
		this.trail1Array = [];
		this.junkArray = [];
		this.planetArray = [];
		cm.main.garbageCollected = [];

		this.junkTrailPos = [
			[{ x: -567, y: -151 }, { x: 26, y: -136 }, { x: 323, y: 126 }, { x: 465, y: -179 }, { x: 495, y: -273 }, { x: 901, y: -202 }, { x: 1117, y: -136 }, { x: 1383, y: -129 }, { x: 1648, y: -228 }, { x: 1939, y: -219 }, { x: 2018, y: -27 }],
			[{ x: -363, y: -144 }, { x: -18, y: -137 }, { x: 305, y: 97 }, { x: 481, y: -200 }, { x: 510, y: -282 }, { x: 910, y: -201 }, { x: 1078, y: -140 }, { x: 1379, y: -139 }, { x: 1662, y: -234 }, { x: 1954, y: -224 }, { x: 2033, y: -19 }],
			[{ x: -351, y: -114 }, { x: 44, y: -129 }, { x: 275, y: 104 }, { x: 453, y: -185 }, { x: 489, y: -274 }, { x: 896, y: -197 }, { x: 1078, y: -137 }, { x: 1391, y: -137 }, { x: 1674, y: -238 }, { x: 1939, y: -219 }, { x: 2039, y: -56 }]
		];
		this.dustContainer = new cjs.Container();
		this.sparkleContainer = new cjs.Container();
		this.addChild(this.spaceContainer);

		this.keyNav = new cm.KeyBoardNav();
		this.keyNav.navArrow = this.navArrow = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-home-btn").set({visible:false, mouseEnabled: false}).center();

		this.checkSettings();
		this.addMap();
		this.addShip();
		// this.addTopGradient();
		this.addUI();

		this.addShipSettings();
	};

	p.addShipSettings = function()
	{
		this.settingShip = new cm.SettingShip();
		this.addChild(this.settingShip);
	};

	p.addUpgradeWindow = function()
	{
		var bgGraphic = new cjs.Graphics();
		bgGraphic.f("#000").r(0,0,cm.app.display.width, cm.app.display.height);
		this.backGroundShape = new cjs.Shape(bgGraphic);
		this.backGroundShape.regX = cm.app.display.width * 0.5;
		this.backGroundShape.regY = cm.app.display.height * 0.5;
		this.backGroundShape.alpha = 0.4;
		this.backGroundShape.on("mousedown", this.hideUpgradeWindow, this);
		this.backGroundShape.visible = true;

		this.upgradeContainer = new cjs.Container().set({ name: 'upgrade-container' });
		this.upgradeCloseButtonCont = new cjs.Container().set({ name: "upgrade-close-btn", y: 189, mouseChildren: false });
		var upgradeWindow = new cjs.Sprite(cm.Assets.lib.gameSS, "upgrade-pop-up").set({x:0, y:0, mouseEnabled: false}).center();


		var upgradeBtnBg = new cjs.Sprite(cm.Assets.lib.gameSS, "close-how-to-bg").set({name: "upgrade-close-btn"}).center();
		var upgradeCloseBtn = new cjs.Sprite(cm.Assets.lib.gameSS, "close-how-to-btn").center();
		this.upgradeCloseButtonCont.on("mousedown", this.buttonHandler, this);
		this.upgradeCloseButtonCont.on("mouseover", this.buttonHandler, this);
		this.upgradeCloseButtonCont.on("click", this.hideUpgradeWindow, this);
		this.upgradeCloseButtonCont.addChild(upgradeBtnBg, upgradeCloseBtn);

		this.keyNav.buttons.push(this.upgradeCloseButtonCont);
		this.upgradeCloseButtonCont.placeArrow = "up";

		var upgradeText = new cjs.Sprite(cm.Assets.lib.gameSS, "upgrade").set({name: "upgrade", x:9, y:-79, mouseEnabled: false}).center();

		var upgradeWave = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-wave").set({name: "sort-wave", visible: false, x:6, y:-100, mouseEnabled: false}).center();

		var upgradeItem = new cjs.Sprite(cm.Assets.lib.gameSS, "upgrade-claw-"+cm.main.gameSettings.grapple).set({name: "upgrade-claw", visible: false, x:0, y:-79, mouseEnabled: false}).center();

		var starNumLength= cm.main.gameSettings.grapple === 2 ? 4 : 5;

		var collectedWidth = 0;
		var starContainer = new cjs.Container().set({ mouseEnabled: false });
		var xPos = 0;
		for (var i = 0, l = starNumLength; i < l; i++) {
			var star;

			star = new cjs.Sprite(cm.Assets.lib.gameSS, "upgrade-star").set({ name: "upgrade-star" }).center();
			star.x = xPos;
			star.y = 37;
			collectedWidth = star.regX + 36;
			star.regX = 0;
			xPos += 80;
			starContainer.addChild(star);
		}
		starContainer.regX = ((collectedWidth) * i) * 0.5;
		starContainer.x = 0;
		starContainer.y = 25;

		cjs.Tween.get(upgradeWave, {loop: true})
		.wait(100)
		.call(upgradeWave.gotoAndPlay, ["zap-2"], upgradeWave)
		.wait(100)
		.call(upgradeWave.gotoAndPlay, ["zap-3"], upgradeWave)
		.wait(100)
		.call(upgradeWave.gotoAndPlay, ["zap-4"], upgradeWave)
		.wait(100)
		.call(upgradeWave.gotoAndPlay, ["zap-1"], upgradeWave);


		this.upgradeContainer.addChild(upgradeWindow, this.upgradeCloseButtonCont, starContainer, upgradeText, upgradeWave, upgradeItem, this.navArrow);
		this.addChild(this.backGroundShape, this.upgradeContainer);
		this.upgradeMessage(upgradeText, upgradeWave, upgradeItem);
	};

	p.upgradeMessage = function(text, wave, item)
	{
		cjs.Tween.get(text).wait(4000).set({visible: false});
		cjs.Tween.get(wave).wait(4000).call(this.playNoiseSfx, null, this).set({visible: true}).wait(2000).set({visible:false});
		cjs.Tween.get(item).wait(6000).set({visible: true});
	};
	p.playNoiseSfx = function()
	{
		app.sound.play("claw-upgrade");
	};
	p.hideUpgradeWindow = function()
	{
		this.backGroundShape.visible = false;
		cjs.Tween.get(this.upgradeContainer).to({y:-800}, 500, cjs.Ease.backIn).set({visible:false});
		var upgradeVo = [500, "vo-29", "vo-31"];
		app.voPlayer.play(upgradeVo[cm.main.gameSettings.grapple-1]);
		this.spaceContainer.addChild(this.navArrow);

	};

	p.checkStorages = function () {
		var storedGameSettings = localStorage.getItem('storedSettings');

		if (storedGameSettings === null) {
			storedGameSettings = {
				grapple:1,
				trashCollected:0,
				presentCollected: false,
				endLevelVoPlayed: false,
				shipPos:{
					x: -350,
					y: 0
				},
				level1: {
					challenge: 1,
					stars: 0
				},
				level2: {
					challenge: 1,
					stars: 0
				},
				level3: {
					challenge: 1,
					stars: 0
				},
				level4: {
					challenge: 1,
					stars: 0
				},
				level5: {
					challenge: 1,
					stars: 0
				},
				level6: {
					challenge: 1,
					stars: 0
				},
				level7: {
					challenge: 1,
					stars: 0
				},
				level8: {
					challenge: 1,
					stars: 0
				},
				level9: {
					challenge: 1,
					stars: 0
				},
				level10: {
					challenge: 1,
					stars: 0
				},
				level11: {
					challenge: 1,
					stars: 0
				}
			};
			this.storedSettings = storedGameSettings;
			localStorage.setItem('storedSettings', JSON.stringify(storedGameSettings));
		} else {
			this.storedSettings = JSON.parse(storedGameSettings);
		}
		if (cm.main.gameSettings === null) {
			cm.main.gameSettings = this.storedSettings;
		}

		this.checkShipPos();
	};

	p.checkShipPos = function()
	{
		var storedPosition = cm.main.gameSettings.shipPos;
		if(cm.main.lastPos !== storedPosition)
			cm.main.lastPos = storedPosition;
	};

	p.checkSettings = function () {
		for (var i = 1, l = 12; i < l; i++) {
			if(cm.main.gameSettings.trashCollected> this.storedSettings.trashCollected)
				this.storedSettings.trashCollected = cm.main.gameSettings.trashCollected;

			if(cm.main.gameSettings["level"+i].challenge > this.storedSettings["level"+i].challenge){
				cjs.Tween.get(this).wait(1000).call(this.triggerCleanTrail, [i], this);
			}

			if(cm.main.gameSettings["level"+i].challenge < this.storedSettings["level"+i].challenge){
				cm.main.gameSettings["level"+i].challenge = this.storedSettings["level"+i].challenge;
			}

			if(cm.main.gameSettings["level"+i].stars > this.storedSettings["level"+i].stars){
				if(cm.main.gameSettings["level"+i].stars === 5)
					app.voPlayer.play("vo-184");
			}

		}

		if(cm.main.gameSettings.presentCollected && !this.storedSettings.presentCollected){
			this.storedSettings.presentCollected = cm.main.gameSettings.presentCollected;
			this.presentAppear = true;
			app.voPlayer.play("vo-25");
		}

		if(cm.main.gameSettings.level4.challenge > 1 && cm.main.gameSettings.level5.challenge < 2 && cm.main.gameSettings.grapple === 1 || cm.main.gameSettings.level7.challenge > 1 && cm.main.gameSettings.level8.challenge < 2 && cm.main.gameSettings.grapple === 2){
			cjs.Tween.get(this).wait(1100).call(this.upgradeWindowSetup, null, this);
		} else {
			this.addLevelTrays();
		}

		localStorage.setItem('storedSettings', JSON.stringify(cm.main.gameSettings));
	};

	p.upgradeWindowSetup = function()
	{
		cm.main.gameSettings.grapple++;
		var upgradeVo = [500, "vo-28", "vo-30"];
		app.voPlayer.play([upgradeVo[0], upgradeVo[cm.main.gameSettings.grapple-1]]);
		this.addUpgradeWindow();
		this.addLevelTrays();
	};

	p.triggerCleanTrail = function(num){
		var junkPath = this.junkArray[num-1];
		if(junkPath.alpha === 0){return;}
		cjs.Tween.get(junkPath).wait(3000).call(this.createParticleSparkle, [junkPath], this).to({alpha: 0}, 1000);
		this.spaceContainer.addChild(this.dustContainer, this.sparkleContainer);
		this.createParticleDust(junkPath);
		this.newJunkTrail(junkPath);
		this.storedSettings["level"+i].challenge = cm.main.gameSettings["level"+i].challenge;
	};

	p.setPositionMap = function(planet)
	{
		var targetX = Math.limit(planet.x * -1, -2048, 0);
		cjs.Tween.get(this.spaceContainer).to({ x: targetX}, 1500, cjs.Ease.quadInOut);
	};

	p.newJunkTrail = function(junkPath)
	{
		if(!app.voPlayer.playing){
			var voEndLevel = ["vo-113", "vo-114", "vo-115"];
			if(cm.main.gameSettings["level"+junkPath.levelNum].stars < 2+cm.main.gameSettings.grapple){
				app.voPlayer.play("vo-24");
			} else
			{
				if(cm.main.gameSettings.level10.challenge === 1){
					app.voPlayer.play(voEndLevel[cm.main.gameSettings.grapple-1]);
				}
			}
		}
		var indexNum = junkPath.parent.getChildIndex(junkPath);
		var newChallenge = cm.main.gameSettings.grapple+1;
		if(newChallenge > 3){return;}
		var newJunk = new cjs.Sprite(cm.Assets.lib.trailSS, "level-" + junkPath.levelNum + "-"+newChallenge+"-trash").set({ levelNum: junkPath.levelNum, challengeNum: newChallenge, name: "level-" + junkPath.levelNum + "-"+newChallenge+"-trash", x: this.junkTrailPos[newChallenge-1][junkPath.levelNum-1].x, y: this.junkTrailPos[newChallenge-1][junkPath.levelNum-1].y, alpha:0 });
		this.spaceContainer.addChildAt(newJunk, indexNum+1);
		cjs.Tween.get(newJunk).wait(3000).to({alpha: 1}, 1000);
	};

	p.createParticleSparkle = function(path) {
		var bounds = path.getBounds();
		for (var i = 0, l = 20; i < l; i++) {
			var ranScale = Math.range(0.3, 0.5);
			var ranXpos = Math.range(path.x, path.x+bounds.width-50);
			var ranYPos = Math.range(path.y, path.y+bounds.height);
			var ranRotate = Math.range(-360,360);
			var ranWait = Math.range(500, 2000);
			var sparkle = new cjs.Sprite(cm.Assets.lib.gameSS, "particle").center().set({x:ranXpos, y: ranYPos, alpha:0});
			cjs.Tween.get(sparkle).wait(ranWait).to({scaleX:ranScale, scaleY:ranScale, rotation:ranRotate, alpha:1}, 500).to({scaleX:0, scaleY:0, rotation:ranRotate*2, alpha:0}, 500);
			this.sparkleContainer.addChild(sparkle);

		}
	};

	p.createParticleDust = function(path) {
		var bounds = path.getBounds();
		for (var i = 0, l = 10; i < l; i++) {
			var ranScale = Math.range(0.3, 0.5);
			var ranXpos = Math.range(path.x, path.x+bounds.width);
			var ranYPos = Math.range(path.y, path.y+bounds.height);
			var ranRotate = Math.range(0,360);
			var ranWait = Math.range(500, 3000);
			var dust = new cjs.Sprite(cm.Assets.lib.mapSS, "dust").center().set({x:ranXpos, y: ranYPos, alpha:0});
			cjs.Tween.get(dust).wait(ranWait).to({scaleX:ranScale, scaleY:ranScale, rotation:ranRotate, alpha:1}, 1500).to({scaleX:0, scaleY:0, rotation:ranRotate*2, alpha:0}, 1500);
			this.dustContainer.addChild(dust);

		}
	};

	p.addUI = function () {
		this.settingsContainer = new cjs.Container();
		this.arrowRightContainer = new cjs.Container();
		this.arrowLeftContainer = new cjs.Container();
		this.stackContainer = new cjs.Container();

		var settingsBg = new cjs.Sprite(cm.Assets.lib.mapSS, "settings-bg").center();
		settingsBg.set({ name: "settings-bg" });
		var settingsBtn = new cjs.Sprite(cm.Assets.lib.mapSS, "settings").center();
		settingsBtn.set({ name: "settings-btn", snapToPixel: false, x: -3, y: 2 });
		this.settingsContainer.set({ x: -this.width + 98, y: -331, name: "settings-bg", mouseChildren: false });
		this.settingsContainer.addChild(settingsBg, settingsBtn);
		this.settingsContainer.placeArrow = "up";
		this.keyNav.buttons.push(this.settingsContainer);
		this.settingsContainer.on("mouseover", this.buttonHandler, this);
		this.settingsContainer.on("mouseout", this.buttonHandler, this);
		this.settingsContainer.on("mousedown", this.buttonHandler, this);
		this.settingsContainer.on("click", this.buttonHandler, this);

		var arrowRightBg = new cjs.Sprite(cm.Assets.lib.mapSS, "arrow-bg").set({ name: "arrowRightBtn" }).center();
		var arrowRightBtn = new cjs.Sprite(cm.Assets.lib.mapSS, "arrow").set({ x: -5, y: 0, mouseEnabled: false, snapToPixel: false }).center();
		this.arrowRightContainer.set({ x: this.width - 50, y: 0, name: "arrowRightBtn", mouseChildren: false });
		this.arrowRightContainer.addChild(arrowRightBg, arrowRightBtn);
		this.arrowRightContainer.on("mouseover", this.buttonHandler, this);
		this.arrowRightContainer.on("mouseout", this.buttonHandler, this);
		this.arrowRightContainer.on("mousedown", this.buttonHandler, this);
		this.arrowRightContainer.on("click", this.buttonHandler, this);

		var arrowLeftBg = new cjs.Sprite(cm.Assets.lib.mapSS, "arrow-bg").set({ name: "arrowLeftBtn" }).center();
		var arrowLeftBtn = new cjs.Sprite(cm.Assets.lib.mapSS, "arrow").set({ x: -5, y: 0, mouseEnabled: false, snapToPixel: false }).center();
		this.arrowLeftContainer.set({ x: -this.width - 50, y: 0, name: "arrowLeftBtn", scaleX: -1, mouseChildren: false });
		this.arrowLeftContainer.addChild(arrowLeftBg, arrowLeftBtn);
		this.arrowLeftContainer.on("mouseover", this.buttonHandler, this);
		this.arrowLeftContainer.on("mouseoout", this.buttonHandler, this);
		this.arrowLeftContainer.on("mousedown", this.buttonHandler, this);
		this.arrowLeftContainer.on("click", this.buttonHandler, this);

		var stackBackGround = new cjs.Sprite(cm.Assets.lib.mapSS, "stack-bg").set({ name: "stack-bg" }).center();
		var stackBtn = new cjs.Sprite(cm.Assets.lib.mapSS, "stack").set({ x: 3, y: -7, mouseEnabled: false, snapToPixel: false }).center();
		this.stackContainer.addChild(stackBackGround, stackBtn);
		this.stackContainer.set({ x: -this.width + 98, y: 250, name: "stack-button", mouseChildren: false });
		this.stackContainer.placeArrow = "left";
		this.keyNav.buttons.push(this.stackContainer);
		this.stackContainer.on("mouseover", this.buttonHandler, this);
		this.stackContainer.on("mouseout", this.buttonHandler, this);
		this.stackContainer.on("mousedown", this.buttonHandler, this);
		this.stackContainer.on("click", this.buttonHandler, this);

		if(!cm.main.gameSettings.presentCollected)
			this.stackContainer.visible = false;

		if(this.presentAppear){
			this.stackContainer.scaleX = this.stackContainer.scaleY = 0;
			new cjs.Tween.get(this.stackContainer).wait(3000).call(this.sparkleBurst, [this.stackContainer.x, this.stackContainer.y], this).to({scaleX:1, scaleY:1}, 500, cjs.Ease.bounceOut);
		}

		// if(cm.main.gameSettings.level1.challenge < 2)
			// this.stackContainer.visible = false;

		this.addChild(this.settingsContainer, this.stackContainer, this.arrowRightContainer, this.arrowLeftContainer);
		if(!this.upgradeContainer){
			this.spaceContainer.addChild(this.navArrow);
		}
		this.addMeters();
	};

	p.sparkleBurst = function(px, py)
	{
		var sparkleContainer = new cjs.Container();
		for (var i = 0, l = 10; i < l; i++) {
			var sparkle = new cjs.Sprite(cm.Assets.lib.gameSS, "particle").center();
			sparkle.x  = 0;
			sparkle.y = 0;
			var toX = Math.range(-150, 150);
			var toY =Math.range(-150, 150);
			sparkle.alpha = sparkle.scaleY = sparkle.scaleX = 0;
			var randomSpeed = Math.range(300, 700);
			var ranScale = Math.range(0.5, 0.8);

			new cjs.Tween.get(sparkle).wait(250).to({x:toX*0.8, y:toY*0.8, alpha:1, scaleX:ranScale, scaleY:ranScale}, 250).to({x:toX, y:toY, alpha:0, scaleX:0, scaleY:0}, randomSpeed);
			sparkleContainer.addChild(sparkle);
		}
		cjs.Tween.get(this).wait(250).call(this.playSparkleSound, null, this);
		app.sound.play("present-popup");
		sparkleContainer.x = px;
		sparkleContainer.y = py;
		this.addChild(sparkleContainer);
		// cjs.Tween.get(this).wait(1000).call(this.removeContainer, [sparkleContainer], this);
	};

	p.playSparkleSound = function()
	{
		app.sound.play("present-fanfare");
	};

	p.addMeters = function()
	{
		this.meterContainer = new cjs.Container().set({ mouseEnabled: false });

		this.trashMeter = new cjs.Sprite(cm.Assets.lib.gameSS, "trash-meter").set({x: -135, y:7, name: "trash-meter"}).center();
		this.starMeter = new cjs.Sprite(cm.Assets.lib.gameSS, "star-meter").set({x: 100, name: "star-meter"}).center();
		var fontSize = 34;
		var score = cm.main.gameSettings.trashCollected;
		if(score > 999){
			var newNum = score/1000;
			score = newNum.toFixed(1)+"K";
		}

		var trashtextStroke = new cjs.Text(score, fontSize+"px riffic-bold", "#7e3318").set({outline:2, x:this.trashMeter.x+30, y:6, textAlign:"center", textBaseline: "middle"});
		var trashtext = new cjs.Text(score, fontSize+"px riffic-bold", "#fcfad8").set({x:this.trashMeter.x+30, y:6, textAlign:"center", textBaseline: "middle"});

		var textWidth = trashtextStroke.getMeasuredWidth();
		if(textWidth > 100){
			this.checkFontSize(trashtextStroke, fontSize);
			this.checkFontSize(trashtext, fontSize);
		}
		var starNum = 0;
		for (var i = 1, l = 11; i < l; i++) {
			starNum += cm.main.gameSettings["level" + i].stars;
		}
		var startextStroke = new cjs.Text(starNum+"/50", fontSize+"px riffic-bold", "#7e3318").set({outline:2, x:this.starMeter.x+16, y:7, textAlign:"center", textBaseline: "middle"});
		var startext = new cjs.Text(starNum+"/50", fontSize+"px riffic-bold", "#fcfad8").set({x:this.starMeter.x+16, y:7, textAlign:"center", textBaseline: "middle"});

		this.meterContainer.y = -342;
		this.meterContainer.addChild(this.trashMeter, this.starMeter, trashtext, trashtextStroke, startext, startextStroke);
		this.addChild(this.meterContainer);
	};

	p.checkFontSize = function(text, fontSize)
	{
		fontSize--;
		var font = fontSize+"px riffic-bold";
		text.font = font;
		var textWidth = text.getMeasuredWidth();
		if(textWidth> 100)
			this.checkFontSize(text, fontSize);

	};

	p.addMap = function () {
		this.background = new cjs.Bitmap(cm.Assets.lib.spacemap);
		this.background.set({ name: 'background', regX: 0, regY: 384, x: -this.width, snapToPixel: false });
		var trashPatchLeft = new cjs.Sprite(cm.Assets.lib.mapLockSS, "trash-patch").center().set({ x: -523, y: -94, mouseEnabled: false });
		this.addChildAt(this.background, 0);
		this.spaceContainer.addChild(trashPatchLeft);
		this.addTrails();
	};

	p.addTrails = function () {
		var Pos = [{ x: -321, y: -163 }, { x: 360, y: -254 }, { x: 1075, y: -264 }, { x: 1789, y: -254 }];
		for (var i = 1, l = 5; i < l; i++) {
			var trail = new cjs.Sprite(cm.Assets.lib.trailSS, "map-trail-" + i).set({ name: "map-trail-" + i, x: Pos[i - 1].x, y: Pos[i - 1].y, mouseEnabled: false });
			this.spaceContainer.addChild(trail);
		}
		this.addJunkTrail();

	};

	p.addJunkTrail = function () {

		for (var i = 1, l = 11; i < l; i++) {
			var challengeNum = this.storedSettings["level"+i].challenge;
			var isVisible = true;
			if(challengeNum >3){
				challengeNum = 3;
				isVisible = false;
			}
				var junk = new cjs.Sprite(cm.Assets.lib.trailSS, "level-" + i + "-"+challengeNum+"-trash").set({ name: "arrowLeftBtn" }).set({ levelNum: i, challengeNum: challengeNum, name: "level-" + i + "-"+challengeNum+"-trash", x: this.junkTrailPos[challengeNum-1][i - 1].x, y: this.junkTrailPos[challengeNum-1][i - 1].y, visible:isVisible, mouseEnabled: false });
				this.junkArray.push(junk);
				this.spaceContainer.addChild(junk);
		}
		this.addPlanets();
	};

	p.addPlanets = function () {
		var string, planet, planetGlow;
		var positions = [{ x: 26, y: -136 }, { x: 323, y: 126 }, { x: 681, y: 136 }, { x: 536, y: -231 }, { x: 1039, y: -235 }, { x: 1090, y: 141 }, { x: 1383, y: -129 }, { x: 1658, y: 81 }, { x: 1984, y: -199 }, { x: 2036, y: 92 }, { x: 2416, y: -40 }];
		var glowPositions = [{ x: 26, y: -136 }, { x: 323, y: 126 }, { x: 679, y: 136 }, { x: 534, y: -228 }, { x: 1037, y: -229 }, { x: 1088, y: 139 }, { x: 1382, y: -138 }, { x: 1657, y: 80 }, { x: 1987, y: -198 }, { x: 2035, y: 93 }, { x: 2416, y: -40 }];
		var lastChallenge = 0;
		for (var i = 0, l = 11; i < l; i++) {
			var num = i + 1;
			if (lastChallenge > 1 && i < 11|| i < 1) {
				string = "level-" + (i + 1) + "-map-btn";
			} else {
				string = "level-" + (i + 1) + "-map-lock";
			}

			planet = new cjs.Sprite(string.indexOf('-lock') > -1 ? cm.Assets.lib.mapLockSS : cm.Assets.lib.mapSS, string).set({ name: string, levelNum: i + 1 }).center();
			planet.set(positions[i]);
			planet.snapToPixel = false;
			var randNeg = Math.random() < 0.5 ? -1 : 1;
			if(i < 10){
				planetGlow = new cjs.Sprite(cm.Assets.lib.mapSS, "level-" + (i + 1) + "-glow").set({ visible: false, name: "level-" + (i + 1) + "-glow", mouseEnabled: false}).center();
				planetGlow.set(glowPositions[i]);
				planetGlow.snapToPixel = false;
				planet.glow = planetGlow;
				if (!cm.Device.iPad2) {
					cjs.Tween.get(planet, {loop:true}).to({y:planet.y+10*randNeg}, 3000).to({y:planet.y}, 3000);
					cjs.Tween.get(planet.glow, {loop:true}).to({y:planet.glow.y+10*randNeg}, 3000).to({y:planet.glow.y}, 3000);
				}
				this.spaceContainer.addChild(planetGlow, planet);
			}
			else{
				if (!cm.Device.iPad2) {
					cjs.Tween.get(planet, {loop:true}).to({y:planet.y+10*randNeg}, 3000).to({y:planet.y}, 3000);
				}
				this.spaceContainer.addChild(planet);
			}
			this.planetArray.push(planet);
			if(i === 3 && cm.main.gameSettings.grapple < 2){
				var grappleIcon = new cjs.Sprite(cm.Assets.lib.gameSS, "grapple-icon-2").center().set({x:planet.x, y:planet.y-70, mouseEnabled: false});
				this.spaceContainer.addChild(grappleIcon);
			}

			if(i === 6 && cm.main.gameSettings.grapple < 3){
				var grappleIcon2 = new cjs.Sprite(cm.Assets.lib.gameSS, "grapple-icon-3").center().set({x:planet.x, y:planet.y-130, mouseEnabled: false});
				this.spaceContainer.addChild(grappleIcon2);
			}

			if(i === 10){
				var playIcon = new cjs.Sprite(cm.Assets.lib.gameSS, "play-icon").center().set({x:planet.x+10, name:'btn-play-video'});
				if(string === "level-11-map-btn")
					playIcon.y = planet.y-50;
				else
					playIcon.y = planet.y-140;

				this.spaceContainer.addChild(playIcon);

			}

			if(i < 1)
				this.setUpPlanetEvents(planet, 2);
			else
				this.setUpPlanetEvents(planet, lastChallenge);

			lastChallenge = cm.main.gameSettings["level" + num].challenge;
		}
		this.spaceContainer.addChild(this.levelUI);
		this.scaleNextPlanet();
	};

	p.setUpPlanetEvents = function (planet, lastChallenge)
	{
		if (lastChallenge > 1 && planet.levelNum < 12) {
			planet.on("mousedown", this.planetHandler, this);
			planet.on("click", this.planetHandler, this);
			planet.placeArrow = "up";
			this.scalePlanet = planet;
			this.keyNav.buttons.push(planet);

			if ( planet.levelNum === 11 ) {
				this.spaceContainer.getChildByName('btn-play-video').on('click', this.planetHandler, this);
			}
		} else{
			planet.on("click", this.planetLockedHandler, this);
		}
	};

	p.scaleNextPlanet = function()
	{
		if(cm.main.gameSettings.level10.challenge > 1 && !cm.main.gameSettings.endLevelVoPlayed){
			app.voPlayer.play([2000, "vo-32"]);
			cm.main.gameSettings.endLevelVoPlayed = true;

		}
		if(cm.main.gameSettings.level10.challenge > 1){
			cm.main.preloadVideo();
		}

		if(this.scalePlanet.glow){
			this.scalePlanet.glow.visible = true;
			if (!cm.Device.iPad2) {
				cjs.Tween.get(this.scalePlanet.glow, {loop:true}).to({scaleX:1.1, scaleY:1.1}, 600, cjs.Ease.quadInOut).to({scaleX:1, scaleY:1}, 600, cjs.Ease.quadInOut);
			}
		}
		cjs.Tween.get(this).wait(2000).call(this.setPositionMap, [cm.main.gameSettings.shipPos], this);
		if (!cm.Device.iPad2) {
			cjs.Tween.get(this.scalePlanet, {loop:true}).to({scaleX:1.1, scaleY:1.1}, 600, cjs.Ease.quadInOut).to({scaleX:1, scaleY:1}, 600, cjs.Ease.quadInOut);
		}
	};


	p.addLevelTrays = function () {

		var string, levelText;
		var positions = [{ x: 31, y: -9 }, { x: 320, y: 220 }, { x: 712, y: 240 }, { x: 532, y: -135 }, { x: 1059, y: -124 }, { x: 1096, y: 246 }, { x: 1383, y: -59 }, { x: 1686, y: 203 }, { x: 2077, y: -167 }, { x: 2125, y: 179 }, { x: 2453, y: 87 }];

		for (var i = 0, l = 10; i < l; i++) {
			string = "level-" + (i + 1) + "-text";
			levelText = new cjs.Sprite(cm.Assets.lib.mapSS, string).set({ name: string, mouseEnabled: false }).center();
			levelText.set(positions[i]);
			this.levelUI.addChild(levelText);

			this.addStars(levelText, i + 1);
		}
	};

	p.addStars = function (level, num) {
		var collectedWidth = 0;
		var starContainer = new cjs.Container().set({ mouseEnabled: false });
		var xPos = 0;
		for (var i = 0, l = cm.main.gameSettings.grapple +2; i < l; i++) {
			var starNum = cm.main.gameSettings["level" + num].stars;
			var star;
			if (i > starNum - 1) {
				star = new cjs.Sprite(cm.Assets.lib.mapSS, "star-empty").set({ name: "star-empty" }).center();
			} else {
				star = new cjs.Sprite(cm.Assets.lib.mapSS, "star").set({ name: "star" }).center();
			}

			star.x = xPos;
			star.y = 50;
			collectedWidth = (star.regX) + 25;
			star.regX = 0;
			xPos += 50;
			starContainer.addChild(star);
		}

		starContainer.regX = ((collectedWidth) * i) * 0.5;
		starContainer.x = level.x;
		starContainer.y = level.y;

		this.levelUI.addChild(starContainer);
	};

	p.addTopGradient = function () {
		var mapGradRight = new cjs.Bitmap(cm.Assets.lib.mapgradient);
		mapGradRight.set({ regX: 0, regY: 384, x: this.width, scaleX: -1 });
		var mapGradLeft = new cjs.Bitmap(cm.Assets.lib.mapgradient);
		mapGradLeft.set({ regX: 0, regY: 384, x: -this.width });
		this.addChild(mapGradRight, mapGradLeft);
	};

	p.addShip = function () {
		this.mapShip = new cm.MapShip();
		this.mapShip.set(cm.main.lastPos);

		if(this.mapShip.x > this.width){
			this.spaceContainer.x -= (this.width + this.mapShip.x) * 0.5;
			if (this.spaceContainer.x < cm.app.display.width - 3904)
			{
				this.spaceContainer.x = cm.app.display.width - 3904;
			}
		}

		this.spaceContainer.addChild(this.mapShip);
	};

	p.start = function () {
		this.View_start();
		app.music = "world-map";
		app.musicInstance.volume = cm.main.musicVolume;
		if(cm.main.gameSettings.level1.challenge === 1){
			if(cm.Device.mobile && cjs.Touch.isSupported())
				app.voPlayer.play([2000, "vo-1"]);
			else
				app.voPlayer.play([2000, "vo-1", "vo-186b"]);
		} else{
			this.unloadCollection();
		}
	};

	p.unloadCollection = function()
	{
		console.log("unload assests");
		cm.Assets.unload(cm.main.currentManifest);

	};

	p.animateIn = function () {
		return 0;
	};

	p.animateOut = function () {
		return 2000;

	};

	p.planetLockedHandler = function(e)
	{
		app.voPlayer.play("vo-112");
		cjs.Tween.get(e.target, {override:true})
		.to({scaleX:1.1, scaleY:1.1}, 200, cjs.Ease.quadOut)
		.to({rotation:30},50)
		.to({rotation:-30},100)
		.to({rotation:30},100)
		.to({rotation:-30},100)
		.to({rotation:0},50)
		.to({scaleX:1, scaleY:1}, 200, cjs.Ease.quadOut);
	};

	p.planetHandler = function (e) {
		if(e.type === "mousedown")
			cjs.Tween.get(e.target).to({ scaleX: 0.9, scaleY: 0.9 }, 150, cjs.Ease.backOut);
			if(e.target.glow)
				cjs.Tween.get(e.target.glow).to({ scaleX: 0.9, scaleY: 0.9 }, 150, cjs.Ease.backOut);

		if(e.type === "click"){
			app.voPlayer.stop();
			if(e.target.levelNum === 11 || e.target.name === 'btn-play-video'){
				cm.main.gameSettings.shipPos = {x: e.target.x, y: e.target.y};
				this.goToEndView();
				return;
			}
			var planetVO;
			cm.main.selectedPlanet = e.target.name;
			cm.main.selectedPlanetNum  = e.target.levelNum;
			if(cm.main.selectedPlanetNum <10)
				planetVO = "vo-10"+cm.main.selectedPlanetNum;
			else
				planetVO = "vo-1"+cm.main.selectedPlanetNum;
			cm.main.previousPos = {x: e.target.x, y: e.target.y};
			app.voPlayer.play(planetVO, this.loadCollection.bind(this));
			cjs.Tween.get(e.target, {override: true})
			.to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.quadIn);
			if(e.target.glow){
				cjs.Tween.get(e.target.glow, {override: true})
				.to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.quadIn);
				e.target.removeAllEventListeners();
			}
			// this.removeAllPlanetEvents();
			// var setBtn = this.settingsContainer.getChildAt(0);
			// setBtn.removeAllEventListeners();
			// var stackBtn = this.stackContainer.getChildAt(0);
			// stackBtn.removeAllEventListeners();
		}
	};

	p.loadCollection = function()
	{
		cm.main.loadSceneTransition(["Collection", "Planet-" + cm.main.selectedPlanetNum], this.goToView.bind(this));
	};

	p.loadStack = function()
	{
		cm.main.loadSceneTransition("Stack", this.goToStackView.bind(this));
	};

	p.removeAllPlanetEvents = function()
	{
		for (var i = 0, l = this.planetArray.length; i < l; i++) {
		   var p = this.planetArray[i];
		   p.removeAllEventListeners();
		}
	};

	p.goToEndView = function()
	{
		if(cm.main.videoPlayer.isVisible){return;}

		if(cm.main.gameSettings.level11.challenge < 4){
			this.storedSettings.level11.challenge = cm.main.gameSettings.level11.challenge = 4;
			localStorage.setItem('storedSettings', JSON.stringify(cm.main.gameSettings));
		}
		var xPos = cm.app.display.width * 0.5;
		if(xPos > 640){
			xPos  = 640;
		}
		this.skipBtn = new cjs.Container().set({ name: 'btn-skip', x: xPos-100, y: 600, mouseChildren: false });
		this.skipBtn.addChild( new cjs.Sprite(cm.Assets.lib.titleSS, "skip-bg").set({name:"skipbg", placeArrow: "down"}).center() );
		this.skipBtn.addChild( new cjs.Sprite(cm.Assets.lib.titleSS, "skip-btn").set({name:"skipbtn" }).center() );
		this.skipBtn.on("mousedown", this.buttonHandler, this);
		this.skipBtn.on("click", this.buttonHandler, this);
		this.skipBtn.on("mouseover", this.buttonHandler, this);
		this.skipBtn.on("mouseout", this.buttonHandler, this);
		this.keyNav.buttons = [];
		this.keyNav.buttons.push(this.skipBtn);
		cm.ViewControl.transitionOverlay.addChildAt(this.skipBtn, 0);
		cm.ViewControl.transitionOverlay.addChildAt(this.navArrow, 2);


		app.musicInstance.volume = 0;
		cjs.Tween.get(this).to({alpha:0}, 500).set({visible:false});
		cjs.Tween.get(this.skipBtn).to({y:190}, 250, cjs.Ease.backOut);


		cm.main.videoPlayer.play(this.goToSpaceView.bind(this));
		cm.main.videoPlayer.isVisible = true;
	};

	p.goToSpaceView = function()
	{
		cm.main.videoPlayer.pause(true);
		cm.main.videoPlayer.isVisible = false;
		cm.main.videoPlayer.video.classList.add("fadeOut");
		cm.ViewControl.gotoView("SpaceView");
		cm.ViewControl.transitionOverlay.removeChild(this.skipBtn);
	};

	p.callSettingShip = function()
	{
		cjs.Tween.get(this.settingsContainer).to({y:-430}, 250, cjs.Ease.quadIn);
		this.settingShip.animateIn();
		var voSettings;
		if(cm.Device.mobile && cjs.Touch.isSupported()){
			voSettings = "vo-118";
		} else{
			voSettings = "vo-193";
		}

		app.voPlayer.play(voSettings);
	};

	p.closeSettingShip = function(){
		this.spaceContainer.addChild(this.navArrow);
		this.navArrow.visible = false;
		cjs.Tween.get(this.settingsContainer).to({y:-331}, 250, cjs.Ease.quadOut);
	};

	p.buttonHandler = function (e) {
		var arrow, icon;
		if (e.type === "mousedown") {
			if(e.target.name === "arrowRightBtn" || e.target.name === "arrowLeftBtn"){
				if (e.target.name === "arrowRightBtn")
					this.moveRight = true;
				if(e.target.name === "arrowLeftBtn")
					this.moveLeft = true;

				arrow = e.target.getChildAt(1);
				cjs.Tween.get(arrow).to({ scaleX: 0.9, scaleY: 0.9 }, 150, cjs.Ease.backOut);
			}

			if (e.target.name === "settings-bg" || e.target.name === "stack-bg" || e.target.name === "upgrade-close-btn") {
				icon = e.target.getChildAt(1);
				cjs.Tween.get(icon).to({ scaleX: 0.9, scaleY: 0.9 }, 150, cjs.Ease.backOut);
			}
		}
		else if (e.type === "click") {

			if (e.target.name === "arrowRightBtn" || e.target.name === "arrowLeftBtn") {
				arrow = e.target.getChildAt(1);
				cjs.Tween.get(arrow).to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.backOut);

				var width = cm.app.display.width*0.5;
				var extra = width * 0.5 * 0.15;
				var targetX = this.spaceContainer.x + (e.target.name === "arrowRightBtn" ? -width : width);
				targetX = Math.limit(targetX, -2048 - extra, extra);

				// tween to it
				cjs.Tween.get(this.spaceContainer).to({ x: targetX }, 800, cjs.Ease.sineInOut);
				cm.app.sound.play("click-1");
			}

			if (e.target.name === "settings-bg") {
				cm.app.voPlayer.stop();
				icon = e.target.getChildAt(1);
				cjs.Tween.get(icon).to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.backOut).call(this.callSettingShip, null, this);
				cm.app.sound.play("click-1");
			}

			if (e.target.name === "stack-button") {
				cm.app.voPlayer.stop();
				icon = e.target.getChildAt(1);
				cjs.Tween.get(icon).to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.backOut).call(this.loadStack, null, this);
				cm.app.sound.play("click-1");
			}

			if (e.target.name === "btn-skip") {
				cjs.Tween.get(e.target.getChildAt(1), { override: true })
				.to({ scaleX: 1, scaleY: 1 }, 240, cjs.Ease.backOut)
				.call(this.goToSpaceView, null, this);
				// e.target.removeAllEventListeners();
			}
		}
		else if(e.type === "mouseover"){
			icon = e.target.getChildAt(1);
			cjs.Tween.get(icon).to({ scaleX: 1.1, scaleY: 1.1 }, 150, cjs.Ease.backOut);
			if(app.voPlayer.playing){return;}
			if(e.target.name === "settings-bg")
				app.voPlayer.play("vo-128");

			if (e.target.name === "arrowRightBtn")
				app.voPlayer.play("vo-125");

			if (e.target.name === "arrowLeftBtn")
				app.voPlayer.play("vo-126");

			if(e.target.name === "btn-skip")
				app.voPlayer.play("vo-121");

			if(e.target.name === "stack-bg")
				app.voPlayer.play("vo-127");

			if(e.target.name === "upgrade-close-btn")
				app.voPlayer.play("vo-164");
		}
		else if(e.type === "mouseout"){
			icon = e.target.getChildAt(1);
			cjs.Tween.get(icon).to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.backOut);
		}
	};

	p.backgroundHandler = function(e) {
		if (e.type === 'mousedown') {
			this.xDifference = this.spaceContainer.x - e.stageX - this.width;
			this.mouseX = e.stageX;
		}
		else if (e.type === 'pressmove') {
			var moveX = this.xDifference + e.stageX - this.width + cm.app.display.width;
			this.spaceContainer.x = moveX;
		}
	};

	p.goToView = function () {
		cm.ViewControl.gotoView("CollectionView");
	};

	p.goToStackView = function()
	{
		cm.ViewControl.gotoView("StackView");
	};

	p.setActive = function (bool) {

		if (bool) {
			this.background.on("pressmove", this.backgroundHandler, this);
			this.background.on("mousedown", this.backgroundHandler, this);
			// this.background.on("pressup", this.backgroundHandler, this);
		}
		else {
			this.keyNav.removeEventsOnButtons();
		}
	};

	p.keyNavHandle = function(button)
	{

		switch(button.name){
			case "settings-bg":
				this.callSettingShip();
			break;
			case "stack-button":
				this.loadStack();
			break;
			case "level-1-map-btn":
			case "level-2-map-btn":
			case "level-3-map-btn":
			case "level-4-map-btn":
			case "level-5-map-btn":
			case "level-6-map-btn":
			case "level-7-map-btn":
			case "level-8-map-btn":
			case "level-9-map-btn":
			case "level-10-map-btn":
				app.voPlayer.stop();
				var planetVO;
				cm.main.selectedPlanet = button.name;
				cm.main.selectedPlanetNum  = button.levelNum;
				if(cm.main.selectedPlanetNum <10)
					planetVO = "vo-10"+cm.main.selectedPlanetNum;
				else
					planetVO = "vo-1"+cm.main.selectedPlanetNum;
				app.voPlayer.play(planetVO, this.loadCollection.bind(this));
				cm.main.previousPos = {x: button.x, y: button.y};
				cjs.Tween.get(button, {override: true}).to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.backOut);
				button.removeAllEventListeners();
				if(button.glow){
					cjs.Tween.get(button.glow, {override: true})
					.to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.backOut);
				}
				this.keyNav.buttons = [];
			break;
			case "level-11-map-btn":
				cm.main.gameSettings.shipPos = {x: button.x, y: button.y};
				this.goToEndView();
				this.keyNav.buttons = [];
			break;
			case "btn-skip":
				this.goToSpaceView();
			break;
			case "upgrade-close-btn":
				this.hideUpgradeWindow();
			break;
		}
	};

	p.checkArrows = function () {
		if (this.spaceContainer.x < 0) {
			if (this.arrowLeftContainer.x < -this.width - 49);
			cjs.Tween.get(this.arrowLeftContainer, { override: true }).to({ x: -this.width + 50 }, 150, cjs.Ease.backOut);
		}
		if (this.spaceContainer.x > -1) {
			if (this.arrowLeftContainer.x > -this.width + 49 && this.arrowLeftContainer.x < -this.width + 51)
				cjs.Tween.get(this.arrowLeftContainer, { override: true }).to({ x: -this.width - 50 }, 150, cjs.Ease.backIn);
		}

		// if (this.spaceContainer.x < cm.app.display.width - 3903) {
		if (this.spaceContainer.x < -2048) {
			if (this.arrowRightContainer.x > this.width - 51 && this.arrowRightContainer.x < this.width - 49)
				cjs.Tween.get(this.arrowRightContainer, { override: true }).to({ x: this.width + 50 }, 150, cjs.Ease.backIn);
		}

		// if (this.spaceContainer.x > cm.app.display.width - 3903) {
		if (this.spaceContainer.x > -2048) {
			if (this.arrowRightContainer.x > this.width + 49 && this.arrowRightContainer.x < this.width + 51)
				cjs.Tween.get(this.arrowRightContainer, { override: true }).to({ x: this.width - 50 }, 150, cjs.Ease.backIn);
		}
	};
	p.checkNavPost = function()
	{
		if(this.navArrow.visible){
			var targetX;
			targetX = Math.limit(this.navArrow.x * -1, -2048, 0);
			cjs.Tween.get(this.spaceContainer).to({ x: targetX}, 800, cjs.Ease.sineInOut);
		}
	};

	p.resize = function()
	{
		this.width = cm.app.display.width * 0.5;

		this.arrowRightContainer.x = this.width - 50;
		this.arrowLeftContainer.x = -this.width - 50;
		this.settingsContainer.x = -this.width + 98;
		this.settingShip.backBtnContainer.x = -this.width + 98;
		this.stackContainer.x = -this.width + 98;
	};
	p.update = function () {
		var extra = cm.app.display.width * 0.5 * 0.15;
		this.spaceContainer.x = Math.limit(this.spaceContainer.x, -2048 - extra, extra);
		this.background.x = (this.spaceContainer.x * 0.2) - this.width - extra;

		this.checkArrows();

		if(cm.Keyboard){
			this.keyNav.keyCheck();
			cm.Keyboard.clearPressed();
		}
	};

	p.destroy = function () {
		this.View_destroy();
	};

	cm.View.SpaceView = cjs.promote(SpaceView, "View");
})();